import { Box, Paper, Divider, useTheme } from '@mui/material';
import { useLocker } from '../context/useLocker';
import { ModalDelete } from '../components/ModalDelete';
import { LockerHeader } from '../components/LockerDatail/LockerHeader';
import { LockerInfo } from '../components/LockerDatail/LockerInfo';
import { NetworkSettings } from '../components/LockerDatail/NetworkSettings';

export default function LockerDetailPage() {
  const theme = useTheme();
  const { 
    lockerData: data,
    isDataLoading: isLoading,
    navigateToEdit,
    openDeleteModal,
    isDeleteModalOpen,
    closeDeleteModal,
    handleDeleteLocker,
    isDeleting
  } = useLocker();

  if (isLoading) return null;
  if (!data) return null;

  return (
    <Box sx={{ width: '100%', maxWidth: 900, mx: 'auto', p: 3 }}>
      <Paper sx={{
        p: 3,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 3,
        boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)'
      }}>
        <LockerHeader 
          data={data}
          onEdit={navigateToEdit}
          onDelete={openDeleteModal}
        />

        <Divider sx={{ my: 3 }} />

        <LockerInfo data={data} />
        <NetworkSettings data={data} />

        <ModalDelete
          open={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDeleteLocker}
          loading={isDeleting}
          title="Confirmar exclusão"
          itemName={`o armário ${data.name}`}
          confirmText="Deletar armário"
        />
      </Paper>
    </Box>
  );
}